var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightAnalysisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 6.24999L10.0001 9.99999M10.0001 9.99999L2.50008 6.24999M10.0001 9.99999V17.9167M12.9817 2.81832L14.6484 3.69332C16.4409 4.63416 17.3376 5.10416 17.8359 5.94999C18.3334 6.79499 18.3334 7.84749 18.3334 9.95166V10.0492C18.3334 12.1525 18.3334 13.205 17.8359 14.05C17.3376 14.8958 16.4409 15.3667 14.6484 16.3075L12.9817 17.1817C11.5184 17.9492 10.7867 18.3333 10.0001 18.3333C9.21341 18.3333 8.48175 17.95 7.01841 17.1817L5.35175 16.3067C3.55925 15.3658 2.66258 14.8958 2.16425 14.05C1.66675 13.205 1.66675 12.1525 1.66675 10.05V9.95249C1.66675 7.84832 1.66675 6.79582 2.16425 5.95082C2.66258 5.10499 3.55925 4.63416 5.35175 3.69416L7.01841 2.81916C8.48175 2.05082 9.21341 1.66666 10.0001 1.66666C10.7867 1.66666 11.5184 2.04999 12.9817 2.81832Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightAnalysisIcon);
export default __webpack_public_path__ + "static/media/light-analysis-icon.398149cdf65ac2613f4d17d4ff232853.svg";
export { ForwardRef as ReactComponent };